export const categories = [
  {
    id: 'hetong-wenshu',
    name: '合同文书',
    slug: 'hetong-wenshu',
    description: '劳动合同、合作协议、采购合同等各类法律文书的协同起草与审阅',
    icon: 'ri-file-text-line',
    articleCount: 24,
    gradient: 'from-primary-500 to-primary-700',
  },
  {
    id: 'chuangyi-wenan',
    name: '创意文案',
    slug: 'chuangyi-wenan',
    description: '广告文案、品牌故事、社交媒体内容的团队共创与灵感碰撞',
    icon: 'ri-lightbulb-line',
    articleCount: 36,
    gradient: 'from-accent-500 to-accent-700',
  },
  {
    id: 'fangan-cehua',
    name: '方案策划',
    slug: 'fangan-cehua',
    description: '活动方案、营销策划、项目计划的结构化协同编写',
    icon: 'ri-pie-chart-line',
    articleCount: 18,
    gradient: 'from-secondary-500 to-secondary-700',
  },
  {
    id: 'jishu-wendang',
    name: '技术文档',
    slug: 'jishu-wendang',
    description: 'API文档、技术规范、开发手册的多人协作维护',
    icon: 'ri-code-line',
    articleCount: 15,
    gradient: 'from-primary-600 to-primary-800',
  },
  {
    id: 'xueshu-lunwen',
    name: '学术论文',
    slug: 'xueshu-lunwen',
    description: '研究报告、学术论文的协同撰写与同行审阅',
    icon: 'ri-book-open-line',
    articleCount: 12,
    gradient: 'from-accent-600 to-accent-800',
  },
  {
    id: 'yingxiao-neirong',
    name: '营销内容',
    slug: 'yingxiao-neirong',
    description: '公众号文章、新闻稿、产品介绍的团队高效产出',
    icon: 'ri-megaphone-line',
    articleCount: 28,
    gradient: 'from-secondary-600 to-secondary-800',
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '如何用一起草高效完成团队合同协作：从起草到签署全流程指南',
    slug: 'team-contract-collaboration-guide',
    excerpt: '还在用邮件来回传合同？一起草的实时协同编辑让法务、业务、管理层同时在线审阅，版本历史一目了然，再也不怕搞混合同版本。',
    cardImage: 'https://readdy.ai/api/search-image?query=Professional%20team%20collaborating%20on%20digital%20contract%20document%20in%20modern%20glass%20office%20with%20warm%20natural%20lighting%20minimalist%20workspace%20clean%20aesthetic%20editorial%20photography&width=600&height=400&seq=article-1-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Professional%20team%20collaborating%20on%20digital%20contract%20document%20in%20modern%20glass%20office%20with%20warm%20natural%20lighting%20minimalist%20workspace%20clean%20aesthetic%20editorial%20photography&width=1200&height=600&seq=article-1-hero&orientation=landscape',
    content: `<p>在现代企业运营中，<strong>合同协作</strong>是最常见的团队文稿场景之一。一份合同的诞生往往需要法务部门审核条款、业务部门确认商务条件、管理层最终审批，整个过程涉及多人、多轮、多版本的反复修改。</p>
<h2>传统合同协作的痛点</h2>
<p>传统的合同协作方式通常是：起草人完成初稿后通过邮件或即时通讯工具发送给相关方，各方分别在自己的副本上修改标注，再由起草人汇总。这种方式存在几个显著问题：</p>
<ul>
<li><strong>版本混乱：</strong>多人同时修改导致存在多个版本，极容易搞混最新版本，甚至将错误版本发送给客户。</li>
<li><strong>沟通效率低：</strong>修改意见分散在邮件、聊天记录中，难以追溯和汇总。</li>
<li><strong>等待时间长：</strong>串行审阅流程导致一份合同可能需要数天才能定稿。</li>
</ul>
<h2>一起草的解决方案</h2>
<p>一起草将合同协作的全流程搬到了云端，实现了真正的<strong>实时共同编辑</strong>：</p>
<h3>1. 在线协同编辑</h3>
<p>法务、业务、管理层可以同时在线查看和编辑同一份合同文档。每个人的修改都会实时同步，光标位置可见，谁在改什么一目了然。</p>
<h3>2. 版本管理</h3>
<p>每一次保存都会自动生成一个版本快照。你可以随时查看历史版本、对比差异、回滚到任意历史版本。再也不用担心「改错了回不去」的问题。</p>
<h3>3. 评论与批注</h3>
<p>团队成员可以在文档的任意位置添加评论和批注，针对特定条款进行讨论。所有讨论记录都留在文档中，方便后续查阅。</p>
<h3>4. 权限控制</h3>
<p>你可以精确控制每个人的权限：谁能查看、谁能评论、谁能编辑。重要的合同条款可以设置为「锁定」状态，只有特定角色才能修改。</p>
<h2>实际操作流程</h2>
<p>以一份<strong>采购合同</strong>的协作为例：</p>
<ol>
<li>采购经理在「一起草」中创建新文档，选择「合同文书」模板</li>
<li>填写基本条款后，邀请法务和财务加入协作</li>
<li>法务在合同中添加法律条款批注，财务确认付款条件</li>
<li>各方在线讨论并达成一致，采购经理定稿</li>
<li>导出为PDF或直接通过电子签章平台完成签署</li>
</ol>
<p>整个过程可以在几小时内完成，而不是几天。这就是一起草带来的<strong>协作效率革命</strong>。</p>`,
    categoryId: 'hetong-wenshu',
    categoryName: '合同文书',
    author: '张明远',
    authorRole: '产品专家',
    publishDate: '2026-08-08',
    readTime: 8,
    imageQuery: 'Professional team collaborating on digital contract document in modern glass office with warm natural lighting minimalist workspace clean aesthetic editorial photography',
    tags: ['合同协作', '团队效率', '版本管理', '在线编辑'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '创意团队的秘密武器：用一起草打造爆款品牌文案',
    slug: 'creative-team-brand-copywriting',
    excerpt: '品牌文案需要灵感的碰撞与反复打磨。一起草为创意团队提供了实时头脑风暴与协同创作的最佳空间，让每一个绝妙创意都被捕捉。',
    content: `<p>对于创意团队来说，<strong>文案创作</strong>从来不是一个线性的过程。它更像是一场持续的头脑风暴——灵感随时可能出现，想法需要不断碰撞和迭代。</p>
<h2>创意协作的独特挑战</h2>
<p>创意团队的文稿协作有其特殊性：</p>
<ul>
<li><strong>灵感稍纵即逝：</strong>好的创意往往在讨论中产生，如果没能及时记录下来，可能就再也想不起来了。</li>
<li><strong>版本迭代频繁：</strong>文案需要反复打磨，一个标题可能有十几个版本，需要对比选择。</li>
<li><strong>多方视角融合：</strong>文案、设计、策略、客户等多方都参与意见，如何高效整合是核心挑战。</li>
</ul>
<h2>一起草的创意工作流</h2>
<h3>实时头脑风暴模式</h3>
<p>团队成员可以同时在文档中自由书写想法，每个人的输入以不同颜色高亮显示。不必等待轮替，所有灵感同时绽放。</p>
<h3>版本对比功能</h3>
<p>当你为一个标题写了五个版本时，一起草的版本对比功能可以并排展示，让你直观地比较每个版本的差异，选出最佳方案。</p>
<h3>客户协作窗口</h3>
<p>你可以为客户创建一个只读或评论权限的共享链接，客户可以直接在文档中添加反馈，而不需要通过邮件来回沟通。</p>
<h2>实战案例：新品上市文案</h2>
<p>某消费品牌在为一款新产品撰写上市文案时使用了「一起草」：</p>
<ol>
<li>策略团队搭建文案框架和核心卖点</li>
<li>创意团队在框架基础上进行文案创作，多人同时贡献不同风格的表达</li>
<li>设计团队查看文案后提出视觉配合建议</li>
<li>客户通过分享链接审阅并添加批注</li>
<li>最终版本在2天内完成，比传统流程缩短了60%</li>
</ol>`,
    categoryId: 'chuangyi-wenan',
    categoryName: '创意文案',
    author: '林小雨',
    authorRole: '创意总监',
    publishDate: '2026-08-06',
    readTime: 7,
    imageQuery: 'Creative team brainstorming around a large screen in bright modern studio with natural light plants and colorful sticky notes editorial style',
    cardImage: 'https://readdy.ai/api/search-image?query=Creative%20team%20brainstorming%20around%20a%20large%20screen%20in%20bright%20modern%20studio%20with%20natural%20light%20plants%20and%20colorful%20sticky%20notes%20editorial%20style&width=600&height=400&seq=article-2-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Creative%20team%20brainstorming%20around%20a%20large%20screen%20in%20bright%20modern%20studio%20with%20natural%20light%20plants%20and%20colorful%20sticky%20notes%20editorial%20style&width=1200&height=600&seq=article-2-hero&orientation=landscape',
    tags: ['创意文案', '品牌故事', '头脑风暴', '团队协作'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '活动策划方案协同编写：从零到一的高效工作流',
    slug: 'event-planning-collaboration-workflow',
    excerpt: '一份完整的活动策划方案涉及预算、流程、分工等多个模块。一起草的模块化编辑让不同负责人各司其职，协同推进方案落地。',
    content: `<p>策划一场活动需要协调预算、场地、流程、人员等多方面因素，<strong>策划方案</strong>的编写通常需要多人分工协作。</p>
<h2>策划方案的传统困境</h2>
<p>一份完整的活动策划方案通常包含：活动概述、目标分析、执行计划、预算明细、应急预案等模块。传统做法是每人负责一个模块，最后由策划经理汇总。但问题在于：各模块之间相互依赖，预算变化会影响执行计划，执行计划调整会影响人员分工。</p>
<h2>一起草的协同策划模式</h2>
<h3>模块化协作</h3>
<p>在一份策划方案中，预算负责人可以直接在预算表格中填写数据，执行负责人可以看到实时更新的预算信息来调整执行计划。所有模块之间的数据联动都是实时可见的。</p>
<h3>评论追审</h3>
<p>策划经理可以对方案中的任意内容添加审批意见。团队成员收到通知后直接修改，审批人可以追踪每条意见的处理状态。</p>
<h3>模板复用</h3>
<p>一起草提供了丰富的策划方案模板。团队可以基于历史成功案例的模板快速启动新的策划工作，不必从零开始。</p>`,
    categoryId: 'fangan-cehua',
    categoryName: '方案策划',
    author: '陈志远',
    authorRole: '项目总监',
    publishDate: '2026-08-04',
    readTime: 6,
    imageQuery: 'Team planning event with laptops sticky notes and large timeline board in modern co-working space warm lighting professional atmosphere',
    cardImage: 'https://readdy.ai/api/search-image?query=Team%20planning%20event%20with%20laptops%20sticky%20notes%20and%20large%20timeline%20board%20in%20modern%20co-working%20space%20warm%20lighting%20professional%20atmosphere&width=600&height=400&seq=article-3-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Team%20planning%20event%20with%20laptops%20sticky%20notes%20and%20large%20timeline%20board%20in%20modern%20co-working%20space%20warm%20lighting%20professional%20atmosphere&width=1200&height=600&seq=article-3-hero&orientation=landscape',
    tags: ['活动策划', '方案协作', '项目计划', '模板'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '技术团队如何用一起草维护高质量的产品文档',
    slug: 'tech-team-product-documentation',
    excerpt: '产品文档需要持续更新维护，技术团队的多人协作让文档与实际开发同步。一起草支持Markdown、代码块和API文档的协同编写。',
    content: `<p>对于技术团队而言，<strong>产品文档</strong>的维护是一项持续的工作。API变更、功能迭代、架构调整都会影响文档的准确性。</p>
<h2>技术文档协作的痛点</h2>
<ul>
<li><strong>文档与代码脱节：</strong>开发人员修改了代码但未同步更新文档</li>
<li><strong>多人修改冲突：</strong>不同开发人员同时修改同一文档产生冲突</li>
<li><strong>格式不一致：</strong>缺少统一的文档规范和模板</li>
</ul>
<h2>一起草的技术文档方案</h2>
<p>一起草提供了完善的<strong>Markdown支持</strong>和代码高亮功能，让技术团队可以用熟悉的语法编写文档。实时协同编辑确保多人修改不会产生冲突。</p>`,
    categoryId: 'jishu-wendang',
    categoryName: '技术文档',
    author: '王鸿飞',
    authorRole: '技术主管',
    publishDate: '2026-08-02',
    readTime: 5,
    imageQuery: 'Developers collaborating on technical documentation with dual monitors showing code and docs in modern minimalist tech office',
    cardImage: 'https://readdy.ai/api/search-image?query=Developers%20collaborating%20on%20technical%20documentation%20with%20dual%20monitors%20showing%20code%20and%20docs%20in%20modern%20minimalist%20tech%20office&width=600&height=400&seq=article-4-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Developers%20collaborating%20on%20technical%20documentation%20with%20dual%20monitors%20showing%20code%20and%20docs%20in%20modern%20minimalist%20tech%20office&width=1200&height=600&seq=article-4-hero&orientation=landscape',
    tags: ['技术文档', 'API文档', 'Markdown', '开发协作'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '学术论文协同撰写：导师与研究生的高效合作模式',
    slug: 'academic-paper-collaboration',
    excerpt: '学术论文的撰写需要导师和学生之间频繁的修改和反馈。一起草让这个过程的沟通成本大幅降低。',
    content: `<p>在学术领域，<strong>论文撰写</strong>是导师和研究生之间最频繁的协作场景。从选题、文献综述到数据分析、结论撰写，每一阶段都需要密切配合。</p>
<h2>传统论文协作的沟壑</h2>
<p>传统的论文撰写模式是：学生完成初稿→发送给导师→导师批注→返回修改→再次提交……这个循环可能需要重复十几次，每次沟通都有信息损耗。</p>
<h2>一起草的学术协作优势</h2>
<h3>实时批注与讨论</h3>
<p>导师可以在文档中直接添加详细批注，学生在同一文档中实时看到反馈并修改。遇到需要讨论的问题，可以在批注中进行线程讨论。</p>
<h3>版本追踪</h3>
<p>每一次修改都有版本记录，导师可以清楚看到学生做了哪些修改，确保反馈得到了落实。</p>
<h3>文献引用管理</h3>
<p>一起草支持参考文献格式管理，团队成员可以在文档中快速插入和管理引用文献。</p>`,
    categoryId: 'xueshu-lunwen',
    categoryName: '学术论文',
    author: '赵博文',
    authorRole: '副教授',
    publishDate: '2026-07-30',
    readTime: 6,
    imageQuery: 'Professor and graduate student reviewing academic paper on large screen in university office with bookshelves warm scholarly atmosphere',
    cardImage: 'https://readdy.ai/api/search-image?query=Professor%20and%20graduate%20student%20reviewing%20academic%20paper%20on%20large%20screen%20in%20university%20office%20with%20bookshelves%20warm%20scholarly%20atmosphere&width=600&height=400&seq=article-5-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Professor%20and%20graduate%20student%20reviewing%20academic%20paper%20on%20large%20screen%20in%20university%20office%20with%20bookshelves%20warm%20scholarly%20atmosphere&width=1200&height=600&seq=article-5-hero&orientation=landscape',
    tags: ['学术论文', '导师协作', '文献管理', '论文修改'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '公众号内容团队的协同利器：从选题到发布一站式管理',
    slug: 'wechat-content-team-collaboration',
    excerpt: '公众号内容团队面临选题排期、多人写稿、编辑审校等多重挑战。一起草让内容生产流程化、透明化。',
    content: `<p>公众号<strong>内容运营</strong>团队每天都要产出多篇高质量文章。从选题会到最终发布，涉及选题策划、资料收集、撰稿、编辑、排版等多个环节。</p>
<h2>内容团队的核心痛点</h2>
<ul>
<li><strong>排期混乱：</strong>选题排期靠Excel管理，更新不及时导致撞车或漏发</li>
<li><strong>稿件流转慢：</strong>撰稿→编辑→审核的串行流程效率低下</li>
<li><strong>风格不统一：</strong>多人写稿导致文风不一致，编辑修改工作量大</li>
</ul>
<h2>一起草的内容协作方案</h2>
<p>一起草为内容团队提供了<strong>选题看板</strong>功能，所有选题的状态（待撰写、撰写中、审核中、待发布）一目了然。团队成员可以同时协作撰写和编辑文章。</p>`,
    categoryId: 'yingxiao-neirong',
    categoryName: '营销内容',
    author: '苏婉清',
    authorRole: '内容运营主管',
    publishDate: '2026-07-28',
    readTime: 5,
    imageQuery: 'Content marketing team collaborating on laptop in modern creative office with editorial calendar on wall bright natural light',
    cardImage: 'https://readdy.ai/api/search-image?query=Content%20marketing%20team%20collaborating%20on%20laptop%20in%20modern%20creative%20office%20with%20editorial%20calendar%20on%20wall%20bright%20natural%20light&width=600&height=400&seq=article-6-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Content%20marketing%20team%20collaborating%20on%20laptop%20in%20modern%20creative%20office%20with%20editorial%20calendar%20on%20wall%20bright%20natural%20light&width=1200&height=600&seq=article-6-hero&orientation=landscape',
    tags: ['公众号', '内容运营', '选题管理', '协同编辑'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '法律团队协作实战：合同条款的多人实时审阅与风险把控',
    slug: 'legal-team-contract-review',
    excerpt: '合同审阅是法律团队的核心工作。一起草的条款级批注和风险标记功能，让律师团队的合同审阅效率提升3倍。',
    content: `<p>法律团队的<strong>合同审阅</strong>工作要求极高的精确度。一个条款的细微措辞差异可能导致完全不同的法律后果。</p>
<h2>法律团队的特殊需求</h2>
<p>法律专业人士对于文稿协作工具有着比普通用户更高的要求：精确的修改追踪、清晰的批注归属、严格的权限控制和合规性保障。</p>
<h2>一起草的法律专业功能</h2>
<h3>条款级高亮与批注</h3>
<p>律师可以针对合同中的具体条款逐条批注，系统自动为每个条款生成编号，方便团队引用和讨论。</p>
<h3>风险等级标记</h3>
<p>对不同风险等级的条款使用红色（高风险）、黄色（中风险）、绿色（低风险）标记，让审阅报告一目了然。</p>
<h3>对比模式</h3>
<p>当收到对方发回的修改版本时，对比模式可以高亮显示所有变更，让律师快速定位差异点。</p>`,
    categoryId: 'hetong-wenshu',
    categoryName: '合同文书',
    author: '周正阳',
    authorRole: '高级合伙人律师',
    publishDate: '2026-07-25',
    readTime: 7,
    imageQuery: 'Legal professionals reviewing contract documents on large monitors in sophisticated law office with wood paneling and warm ambient lighting',
    cardImage: 'https://readdy.ai/api/search-image?query=Legal%20professionals%20reviewing%20contract%20documents%20on%20large%20monitors%20in%20sophisticated%20law%20office%20with%20wood%20paneling%20and%20warm%20ambient%20lighting&width=600&height=400&seq=article-7-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Legal%20professionals%20reviewing%20contract%20documents%20on%20large%20monitors%20in%20sophisticated%20law%20office%20with%20wood%20paneling%20and%20warm%20ambient%20lighting&width=1200&height=600&seq=article-7-hero&orientation=landscape',
    tags: ['法律合同', '条款审阅', '风险把控', '律师协作'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '短视频脚本的团队共创：从脑暴到成片的协同工作流',
    slug: 'short-video-script-collaboration',
    excerpt: '短视频脚本需要在极短时间内完成从创意到成稿的全过程。一起草的实时协作让编导、文案、运营无缝配合。',
    content: `<p>短视频行业的<strong>脚本创作</strong>节奏极快，一条爆款视频从创意到拍摄可能只有几个小时的时间窗口。</p>
<h2>短视频脚本协作特点</h2>
<p>短视频脚本包含画面描述、台词、音效提示等多种元素，需要编导、文案、后期等多个角色紧密配合。</p>
<h2>一起草的快速创作模式</h2>
<h3>分镜脚本模板</h3>
<p>内置短视频分镜脚本模板，包含镜头号、画面描述、台词、时长等标准字段，团队可以直接填入内容。</p>
<h3>创意评论墙</h3>
<p>团队成员可以在文档侧边栏进行即时创意讨论，所有灵感都被记录并可追溯。</p>`,
    categoryId: 'chuangyi-wenan',
    categoryName: '创意文案',
    author: '刘思源',
    authorRole: '内容创意总监',
    publishDate: '2026-07-22',
    readTime: 5,
    imageQuery: 'Creative video team storyboarding with tablets and large display in vibrant modern studio with neon accents and industrial design',
    cardImage: 'https://readdy.ai/api/search-image?query=Creative%20video%20team%20storyboarding%20with%20tablets%20and%20large%20display%20in%20vibrant%20modern%20studio%20with%20neon%20accents%20and%20industrial%20design&width=600&height=400&seq=article-8-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Creative%20video%20team%20storyboarding%20with%20tablets%20and%20large%20display%20in%20vibrant%20modern%20studio%20with%20neon%20accents%20and%20industrial%20design&width=1200&height=600&seq=article-8-hero&orientation=landscape',
    tags: ['短视频', '脚本创作', '内容创意', '快速协作'],
    featured: false,
  },
  {
    id: 'article-9',
    title: '市场调研报告协同撰写：数据分析与结论提炼的最佳实践',
    slug: 'market-research-report-collaboration',
    excerpt: '市场调研报告需要数据团队和分析团队紧密配合。一起草让数据分析与文字撰写同步进行，报告产出周期缩短50%。',
    content: `<p><strong>市场调研报告</strong>的撰写通常涉及数据收集、统计分析、洞察提炼、报告撰写等多个环节，需要数据团队和分析团队的紧密配合。</p>
<h2>调研报告协作的挑战</h2>
<ul>
<li><strong>数据与文字分离：</strong>数据在表格中，分析在文档中，来回切换效率低</li>
<li><strong>图表更新滞后：</strong>数据更新后图表没有同步，导致报告中数据不一致</li>
<li><strong>多人撰写风格不一：</strong>不同部分由不同人撰写，最终报告风格割裂</li>
</ul>
<h2>一起草的解决方案</h2>
<p>一起草支持在文档中嵌入<strong>实时数据表格</strong>和图表，当数据更新时，文档中的图表会自动刷新。多名分析师可以同时在不同章节工作，主编可以在全局视角下协调风格统一。</p>`,
    categoryId: 'fangan-cehua',
    categoryName: '方案策划',
    author: '黄雅婷',
    authorRole: '市场研究经理',
    publishDate: '2026-07-20',
    readTime: 6,
    imageQuery: 'Market research team analyzing data dashboard on multiple screens in bright modern office with charts graphs and collaborative workspace',
    cardImage: 'https://readdy.ai/api/search-image?query=Market%20research%20team%20analyzing%20data%20dashboard%20on%20multiple%20screens%20in%20bright%20modern%20office%20with%20charts%20graphs%20and%20collaborative%20workspace&width=600&height=400&seq=article-9-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Market%20research%20team%20analyzing%20data%20dashboard%20on%20multiple%20screens%20in%20bright%20modern%20office%20with%20charts%20graphs%20and%20collaborative%20workspace&width=1200&height=600&seq=article-9-hero&orientation=landscape',
    tags: ['市场调研', '数据分析', '报告协作', '图表'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '开源项目文档的国际协作：跨越时区的高效协同实践',
    slug: 'open-source-documentation-collaboration',
    excerpt: '开源项目的文档维护涉及全球各地的贡献者。一起草的异步协作和翻译管理功能，让国际化的文档协作不再是难题。',
    content: `<p>开源项目的<strong>文档维护</strong>是一项全球协作的工程。贡献者分布在不同时区，使用不同语言，如何高效协同是一个巨大挑战。</p>
<h2>国际化文档协作的特点</h2>
<p>开源项目文档通常需要维护多个语言版本，且需要与代码版本保持同步。异步协作是常态，实时同步反而是奢侈。</p>
<h2>一起草的开源友好功能</h2>
<h3>异步协作模式</h3>
<p>时区不同没关系，一起草完整记录每个人的修改，你上线时可以看到所有变更的汇总和对比。</p>
<h3>多语言版本管理</h3>
<p>同一份文档可以创建多个语言版本，翻译团队可以基于原文进行翻译，原文更新后自动标记译文需要同步更新的部分。</p>
<h3>与Git工作流集成</h3>
<p>一起草支持导出Markdown格式，可以直接提交到Git仓库，实现文档与代码的版本同步。</p>`,
    categoryId: 'jishu-wendang',
    categoryName: '技术文档',
    author: 'Alex Chen',
    authorRole: '开源项目维护者',
    publishDate: '2026-07-18',
    readTime: 6,
    imageQuery: 'Global distributed team collaborating on open source documentation shown on world map with connected nodes in modern tech workspace',
    cardImage: 'https://readdy.ai/api/search-image?query=Global%20distributed%20team%20collaborating%20on%20open%20source%20documentation%20shown%20on%20world%20map%20with%20connected%20nodes%20in%20modern%20tech%20workspace&width=600&height=400&seq=article-10-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Global%20distributed%20team%20collaborating%20on%20open%20source%20documentation%20shown%20on%20world%20map%20with%20connected%20nodes%20in%20modern%20tech%20workspace&width=1200&height=600&seq=article-10-hero&orientation=landscape',
    tags: ['开源项目', '国际协作', '多语言', '文档管理'],
    featured: false,
  },
  {
    id: 'article-11',
    title: '毕业论文撰写指南：从开题到答辩的协同支持体系',
    slug: 'thesis-writing-collaboration-guide',
    excerpt: '毕业论文从开题到答辩是一个漫长的过程。一起草帮助你和导师建立高效的反馈循环，让论文撰写不再孤单。',
    content: `<p>撰写<strong>毕业论文</strong>是每个研究生最重要也最漫长的学术任务。从开题报告到最终答辩，通常需要数月甚至更长的时间。</p>
<h2>毕业论文撰写的常见困难</h2>
<ul>
<li><strong>反馈周期长：</strong>发给导师的稿件可能要等一周才有回复</li>
<li><strong>结构容易迷失：</strong>长篇论文的结构把控是巨大挑战</li>
<li><strong>参考文献管理混乱：</strong>引用的文献容易丢失或格式错误</li>
</ul>
<h2>一起草的论文支持体系</h2>
<h3>大纲模式</h3>
<p>在撰写正文前先构建论文大纲，导师可以直接在大纲上提供结构调整建议。大纲确认后再开始正文撰写，避免大篇幅返工。</p>
<h3>进度追踪</h3>
<p>设置章节完成目标，导师可以随时查看你的写作进度，在关键节点给予指导。</p>`,
    categoryId: 'xueshu-lunwen',
    categoryName: '学术论文',
    author: '孙雨桐',
    authorRole: '博士研究生',
    publishDate: '2026-07-15',
    readTime: 7,
    imageQuery: 'Graduate student working on thesis at desk surrounded by books and research papers in quiet university library with warm reading lamp light',
    cardImage: 'https://readdy.ai/api/search-image?query=Graduate%20student%20working%20on%20thesis%20at%20desk%20surrounded%20by%20books%20and%20research%20papers%20in%20quiet%20university%20library%20with%20warm%20reading%20lamp%20light&width=600&height=400&seq=article-11-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Graduate%20student%20working%20on%20thesis%20at%20desk%20surrounded%20by%20books%20and%20research%20papers%20in%20quiet%20university%20library%20with%20warm%20reading%20lamp%20light&width=1200&height=600&seq=article-11-hero&orientation=landscape',
    tags: ['毕业论文', '学术写作', '导师指导', '开题报告'],
    featured: false,
  },
  {
    id: 'article-12',
    title: '新闻稿团队协作：从事件发生到稿件发布的极速响应',
    slug: 'press-release-team-rapid-response',
    excerpt: '热点事件稍纵即逝，新闻稿的发布速度决定了传播效果。一起草让采编团队在第一时间完成稿件的协同撰写和审核。',
    content: `<p>在新闻和公关领域，<strong>新闻稿</strong>的时效性至关重要。从事件发生到稿件发布，留给团队的时间可能只有几个小时甚至更短。</p>
<h2>新闻稿协作的速度要求</h2>
<p>一条企业新闻稿从信息收集、稿件撰写、法务审核到最终发布，传统流程可能需要一整天。但在热点事件面前，这个速度远远不够。</p>
<h2>一起草的极速响应模式</h2>
<h3>并行协作</h3>
<p>采编团队收集信息的同步，文案团队就可以开始搭建稿件框架。信息到位后立即填充内容，法务同步审核，实现三线并行。</p>
<h3>审批加速</h3>
<p>一起草的@提醒功能可以立即通知审核人，审核人在手机端也能完成审阅和批注，不因位置限制耽误时间。</p>`,
    categoryId: 'yingxiao-neirong',
    categoryName: '营销内容',
    author: '马晓峰',
    authorRole: '公关总监',
    publishDate: '2026-07-12',
    readTime: 5,
    imageQuery: 'News team rapidly collaborating on breaking news in modern newsroom with multiple screens showing live feeds and editorial workflow',
    cardImage: 'https://readdy.ai/api/search-image?query=News%20team%20rapidly%20collaborating%20on%20breaking%20news%20in%20modern%20newsroom%20with%20multiple%20screens%20showing%20live%20feeds%20and%20editorial%20workflow&width=600&height=400&seq=article-12-card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=News%20team%20rapidly%20collaborating%20on%20breaking%20news%20in%20modern%20newsroom%20with%20multiple%20screens%20showing%20live%20feeds%20and%20editorial%20workflow&width=1200&height=600&seq=article-12-hero&orientation=landscape',
    tags: ['新闻稿', '公关传播', '快速响应', '采编协作'],
    featured: false,
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '李明远',
    role: '法务总监',
    company: '某科技集团',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20headshot%20portrait%20with%20warm%20smile%20clean%20white%20background%20editorial%20photography%20soft%20lighting&width=80&height=80&seq=avatar-t1&orientation=squarish',
    content: '一起草彻底改变了我们团队的合同审阅方式。以前一份合同要来回邮件十几次，现在所有人在同一个文档上协作，效率至少提升了3倍。版本管理功能更是让我们再也不用担心搞混合同版本。',
    rating: 5,
  },
  {
    id: 't2',
    name: '王晓婷',
    role: '创意总监',
    company: '某4A广告公司',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20headshot%20portrait%20confident%20expression%20warm%20lighting%20clean%20white%20background%20modern%20corporate%20style&width=80&height=80&seq=avatar-t2&orientation=squarish',
    content: '对于创意团队来说，灵感的碰撞太重要了。一起草的实时协作让我们的头脑风暴效率远超线下会议，每个人的想法都能被即时捕捉和呈现。用了半年，团队产出效率提升了40%。',
    rating: 5,
  },
  {
    id: 't3',
    name: '陈建国',
    role: 'CTO',
    company: '某SaaS创业公司',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20professional%20headshot%20portrait%20with%20glasses%20friendly%20expression%20modern%20office%20background%20clean%20photography&width=80&height=80&seq=avatar-t3&orientation=squarish',
    content: '作为技术团队，我们对工具的要求很高。一起草不仅支持Markdown，还对代码块的高亮做得很好。我们团队的技术文档全部迁移到了一起草上，协作体验远超传统Wiki工具。',
    rating: 5,
  },
];

export const features = [
  {
    id: 'f1',
    icon: 'ri-group-line',
    title: '实时协同编辑',
    description: '多人同时在线编辑同一份文稿，每个人的修改实时可见，光标位置同步，告别版本混乱。',
  },
  {
    id: 'f2',
    icon: 'ri-history-line',
    title: '智能版本管理',
    description: '自动保存每一次修改的版本快照，随时对比差异、回滚到历史版本，再也不用担心误操作。',
  },
  {
    id: 'f3',
    icon: 'ri-chat-check-line',
    title: '评论与审阅',
    description: '在文档任意位置添加评论和批注，审批流程自动化，让反馈和修改有据可查。',
  },
  {
    id: 'f4',
    icon: 'ri-shield-check-line',
    title: '精细权限控制',
    description: '精确到段落级别的权限管理，谁可以查看、评论、编辑，一切由你掌控。',
  },
  {
    id: 'f5',
    icon: 'ri-file-copy-line',
    title: '丰富模板库',
    description: '内置合同、方案、文案等数百个专业模板，快速启动你的文稿创作，不必从零开始。',
  },
  {
    id: 'f6',
    icon: 'ri-cloud-line',
    title: '云端安全存储',
    description: '银行级数据加密，分布式云端存储，你的每一份文稿都得到最安全的保护。',
  },
];

export const stats = [
  { id: 's1', value: '500,000+', label: '累计用户', icon: 'ri-user-line' },
  { id: 's2', value: '20,000+', label: '企业团队', icon: 'ri-building-line' },
  { id: 's3', value: '100万+', label: '协作文稿', icon: 'ri-file-text-line' },
  { id: 's4', value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
];

export const brandValues = [
  {
    id: 'v1',
    icon: 'ri-rocket-line',
    title: '使命',
    description: '让每一次团队文稿协作都高效顺畅，释放团队的创作潜能。',
  },
  {
    id: 'v2',
    icon: 'ri-eye-line',
    title: '愿景',
    description: '成为全球最受欢迎的多人协同文稿创作平台。',
  },
  {
    id: 'v3',
    icon: 'ri-heart-line',
    title: '价值观',
    description: '用户至上、极致体验、协作共赢、持续创新。',
  },
];

export const milestones = [
  { year: '2024 Q1', event: '一起草项目正式立项，核心团队组建完成' },
  { year: '2024 Q3', event: '完成首个Beta版本，开启内测' },
  { year: '2024 Q4', event: '正式发布V1.0，用户突破10万' },
  { year: '2025 Q2', event: '上线企业版，服务超过5000家企业团队' },
  { year: '2025 Q4', event: '用户突破50万，获年度最佳协作工具奖' },
  { year: '2026 Q1', event: '推出AI智能辅助写作功能' },
  { year: '2026 Q2', event: '累计用户突破50万，企业客户超过2万家' },
];